import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UseraccessserviceService } from '../services/useraccessservice.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard  {

  constructor(private router: Router, private useraccessservice: UseraccessserviceService) {

  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.authChecker(state);
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // NOTE: /user/userprofile is allowed through without a token because it is linked
    // as a public "view this person" page from the forum and admin lists. This is a
    // routing convenience, not an authorization boundary — the API is what protects the
    // data. Tracked for the auth-hardening slice; see docs/refactor/M01-findings.md (A7).
    if (state.url.includes('/user/userprofile')) {
      return true;
    }
    return this.authChecker(state);
  }

  authChecker(state: RouterStateSnapshot) {
    // NOTE: the /user/createschool?dat= bypass appears to be dead — the handoff that
    // produced that URL is commented out in impatasite (register.component.ts:128).
    // Left in place deliberately; removal belongs to the auth-hardening slice (A7).
    if (this.useraccessservice.getCurrentUserToken() != null || state.url.includes("/user/createschool?dat=")) {
      return true;
    } else {
      this.router.navigate(["/access/login"], { queryParams: { url: state.url } });
      return false;
    }
  }

}
